import { Component, effect, input, OnDestroy, signal, OnInit, output, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TextboxComponent } from '../../../common/components/textbox/textbox.component';
import { ModalService } from '../../../common/services/modal.service';
import { StoreService } from '../../../store/store.service';
import { ConfirmationService } from '../confirmation-page/confirmation.service';
import { RouterService } from '../../../common/services/router.service';
import { LayoutService } from '../../../common/services/layout.service';
import { ButtonGroupComponent, ButtonItem } from '../../../common/components/button-group/button-group.component';

@Component({
  selector: 'app-manage-booking',
  templateUrl: './manage-booking.component.html',
  styleUrls: ['./manage-booking.component.scss'],
  imports: [TextboxComponent, ButtonGroupComponent],
})
export class ManageBookingComponent implements OnInit, OnDestroy {
  public isModal = input<boolean>(false);

  public email = signal<string>('');
  public resID = signal<string>('');

  public submitEvent = output<boolean>();

  public readonly buttonGroupOptions = computed((): ButtonItem[] => [
    ...(this.isModal() ? [{
      label: this.storeSvc.localeObj()?.tf_1_Calendar_Loyalty_ManageAccount_btn_cancel,
      variant: 'secondary' as const,
      id: 'manage-booking-cancel',
      value: 'CANCEL'
    }] : []),
    {
      label: this.storeSvc.localeObj()?.tf_5_Confirmation_manageBooking_button_submit,
      variant: 'primary',
      id: 'manage-booking-submit',
      value: 'SUBMIT',
      isLoading: this.confirmationSvc.reservationLookupLoading()
    }
  ]);

  constructor(
    public storeSvc: StoreService,
    public modalSvc: ModalService,
    public confirmationSvc: ConfirmationService,
    public routerSvc: RouterService,
    private route: ActivatedRoute,
    private _layoutSvc: LayoutService,
  ) {
    this.initEffects();
  }

  ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email');
    const confirmNum = this.route.snapshot.queryParamMap.get('confirmNum');

    if (email?.trim()) this.email.set(email.trim());
    if (confirmNum?.trim()) this.resID.set(confirmNum.trim());
  }

  ngOnDestroy(): void {
    this._layoutSvc.unloadPageScripts('ManageBookingLookupPage');
    this.confirmationSvc.isLoyaltyLoginRequired.set(false);
  }

  public initEffects = () => {
    effect(() => {
      if (this._layoutSvc.isPortalScriptsLoaded) {
        this._layoutSvc.executePageScripts('ManageBookingLookupPage');
      }
    });

    effect(() => {
      if (this.confirmationSvc.isLoyaltyLoginRequired() && this.storeSvc.appStore.isLoyaltyMemberSet()) {
        this.confirmationSvc.getReservationLookupApiData(this.resID(), this.email(), true);
        this.confirmationSvc.isLoyaltyLoginRequired.set(false);
      }
    });
  };

  public handleToast = (e: string) => {
    this.modalSvc.displayToastMessage({
      desc: this.storeSvc.userStore.localeObj()?.tf_04_Checkout_manageBooking_errormsg || '',
      type: e,
    });
  };

  public reservationLookup = () => {
    if (!this.resID() || !this.email()) {
      this.handleToast('error');
      return;
    }

    this.confirmationSvc.getReservationLookupApiData(this.resID(), this.email(), true);
    this.submitEvent.emit(true);
  };

  public handleButtonGroupClick = (value: string) => {
    if (value === 'SUBMIT') {
      this.reservationLookup();
    } else if (value === 'CANCEL') {
      this.modalSvc.closeModal();
    }
  };
}
